import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import React from 'react';

import { chainWalk, convertToFixedDP } from '../../../utils/helpers';

const TotalShowHrsTable = ({ plannedNodeThroughput, isDay1NewHireLaborEnabled }) => {
  // TODO: We can remove this flag check once the Day 1 New Hire hours experience
  // is fully dialed up.
  const isShowTotalDay1NewHire =
    isDay1NewHireLaborEnabled && chainWalk(() => plannedNodeThroughput.totalDay1NewHireShowHours, -1) >= 0;

  return (
    <div>
      <Table headerRows={1} showDividers={true} showStripes={false} spacing="small">
        <TableRow>
          {isShowTotalDay1NewHire ? (
            <TableCell alignmentHorizontal="end">
              Total Show Hrs w/o<br></br> Day 1 Show Hrs
            </TableCell>
          ) : (
            <TableCell alignmentHorizontal="end">Total Show Hrs</TableCell>
          )}
          {isShowTotalDay1NewHire && (
            <TableCell alignmentHorizontal="end">
              Total Day 1<br></br>Show Hrs
            </TableCell>
          )}
          <TableCell alignmentHorizontal="end">Total Needed Hrs</TableCell>
          <TableCell alignmentHorizontal="end">Planned TPH with 5s</TableCell>
          <TableCell alignmentHorizontal="end">Planned TPH without 5s</TableCell>
        </TableRow>
        {plannedNodeThroughput ? (
          <TableRow highlightOnHover={true}>
            <TableCell alignmentHorizontal="end">{convertToFixedDP(plannedNodeThroughput.totalShowHours)}</TableCell>
            {isShowTotalDay1NewHire && (
              <TableCell alignmentHorizontal="end">
                {convertToFixedDP(plannedNodeThroughput.totalDay1NewHireShowHours)}
              </TableCell>
            )}
            <TableCell alignmentHorizontal="end">{convertToFixedDP(plannedNodeThroughput.totalNeededHours)}</TableCell>
            <TableCell alignmentHorizontal="end">{convertToFixedDP(plannedNodeThroughput.plannedTphWith5s)}</TableCell>
            <TableCell alignmentHorizontal="end">
              {convertToFixedDP(plannedNodeThroughput.plannedTphWithout5s)}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow highlightOnHover={true}>
            <TableCell alignmentHorizontal="end">0</TableCell>
            <TableCell alignmentHorizontal="end">0</TableCell>
            <TableCell alignmentHorizontal="end">0</TableCell>
            <TableCell alignmentHorizontal="end">0</TableCell>
          </TableRow>
        )}
      </Table>
    </div>
  );
};

export default TotalShowHrsTable;
